import moment from "moment-timezone";
import { CustomHeader } from "tap/components/AGGrid/cell-renderers/CustomHeader.jsx";
import { ClickableCellRenderer } from "tap/components/AGGrid/cell-renderers/ClickableCellRenderer.jsx";

export const id = {
  field: "id",
  headerName: "ID",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "id",
    page: "updateEngine",
  },
  minWidth: 100,
};

export const jobStatus = (onOpenJobViewModal) => ({
  field: "jobStatus",
  headerName: "Status",
  cellRenderer: ClickableCellRenderer(onOpenJobViewModal, "fa-eye"),
  minWidth: 200,
});

export const dealsProcessed = {
  field: "progressCount",
  headerName: "Deals Processed",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "progressCount",
    page: "updateEngine",
  },
  minWidth: 50,
};

export const errorCount = {
  field: "errorCount",
  headerName: "Errors",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "errorCount",
    page: "updateEngine",
  },
  minWidth: 50,
};

export const createdAt = {
  field: "createdAt",
  headerName: "Created",
  valueFormatter: ({ value }) =>
    value
      ? moment(moment.utc(value).toDate())
          .tz(moment.tz.guess())
          .format("MM/DD/YYYY, h:mm:ss A z")
      : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "createdAt",
    page: "updateEngine",
  },
  minWidth: 250,
};

export const completedAt = {
  field: "completedAt",
  headerName: "Completed",
  valueFormatter: ({ value }) =>
    value
      ? moment(moment.utc(value).toDate())
          .tz(moment.tz.guess())
          .format("MM/DD/YYYY, h:mm:ss A z")
      : "",
  headerComponent: CustomHeader,
  headerComponentParams: {
    colId: "completedAt",
    page: "updateEngine",
  },
  minWidth: 250,
};
